import { types } from './types';

const INITIAL_STATE = {
  associates: [],
  loaded: false,
  error: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_ASSOCIATES:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}